export const snippetNameValidation = 'String should not contain quotes'
export const errorGetSessionSnippet = 'Error in fetching session snippets'
export const cancelWorkshopPopupDisclaimer =
  'You may have unsaved changes. Are you sure you want to cancel?'
export const cancelWorkshoppopupHeader = 'Leaving Current Page'
export const systemText =
  'You are a helpful assistant. Reply with short concise response. Do Not repeat yourself, nor repeat the question. Always reply with markdown. Use headings, lists and tables.'
